export const roleAccess = {
  Tenant: ["/", "/tenant/invoices", "/tenant/payments", "/tenant/documents", "/tenant/requests", "/settings"],
  Growth: [
    "/",
    "/properties",
    "/tenants",
    "/payments",
    "/expenses",
    "/invoices",
    "/maintenance",
    "/vendors",
    "/messages",
    "/documents",
    "/calendar",
    "/reports",
    "/ai-assistant",
    "/outreach-agent",
    "/user-management",
    "/settings",
  ],
  Administrator: [
    "/",
    "/properties",
    "/tenants",
    "/payments",
    "/expenses",
    "/invoices",
    "/maintenance",
    "/vendors",
    "/messages",
    "/documents",
    "/calendar",
    "/reports",
    "/ai-assistant",
    "/user-management",
    "/settings",
  ],
  Manager: [
    "/",
    "/properties",
    "/tenants",
    "/maintenance",
    "/vendors",
    "/messages",
    "/documents",
    "/calendar",
    "/reports",
    "/ai-assistant",
    "/settings",
  ],
  Accountant: ["/", "/payments", "/expenses", "/invoices", "/vendors", "/documents", "/calendar", "/reports", "/settings"],
  Maintenance: ["/", "/maintenance", "/vendors", "/messages", "/calendar", "/settings"],
  Viewer: ["/", "/calendar", "/reports", "/settings"],
};

const roleAliases = {
  tenant: "Tenant",
  resident: "Tenant",
  "tenant-user": "Tenant",
  tenant_user: "Tenant",
  growth: "Growth",
  "super admin": "Growth",
  super_admin: "Growth",
  "super-admin": "Growth",
  administrator: "Administrator",
  admin: "Administrator",
  manager: "Manager",
  accountant: "Accountant",
  finance: "Accountant",
  maintenance: "Maintenance",
  agent: "Maintenance",
  "field-agent": "Maintenance",
  field_agent: "Maintenance",
  operations: "Maintenance",
  viewer: "Viewer",
  "read-only": "Viewer",
  readonly: "Viewer",
};

export function normalizeRole(role) {
  const normalizedValue = String(role || "")
    .trim()
    .toLowerCase();

  if (roleAliases[normalizedValue]) {
    return roleAliases[normalizedValue];
  }

  const matchedRole = Object.keys(roleAccess).find(
    (availableRole) => availableRole.toLowerCase() === normalizedValue
  );

  return matchedRole || "Viewer";
}

export function canAccessPath(role, path) {
  const normalizedRole = normalizeRole(role);
  if (path === "/outreach-agent") {
    return normalizedRole === "Growth";
  }
  return roleAccess[normalizedRole].includes(path);
}

export function canManageUsers(role) {
  return ["Administrator", "Growth"].includes(normalizeRole(role));
}
